import { render, staticRenderFns } from "./KoreanLsportCartNew.vue?vue&type=template&id=63a2228e&scoped=true"
import script from "./KoreanLsportCartNew.vue?vue&type=script&lang=js"
export * from "./KoreanLsportCartNew.vue?vue&type=script&lang=js"
import style0 from "./KoreanLsportCartNew.vue?vue&type=style&index=0&id=63a2228e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a2228e",
  null
  
)

export default component.exports